"use strict";

var _regeneratorRuntime = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-ignore

var ethereumjs_wallet_1 = __importDefault(require("ethereumjs-wallet"));

var web3_1 = __importDefault(require("web3"));

var eth_sig_util_1 = __importDefault(require("eth-sig-util"));

var TypedRequestData_1 = require("@opengsn/common/dist/EIP712/TypedRequestData");

var Utils_1 = require("@opengsn/common/dist/Utils");

function toAddress(privateKey) {
  var wallet = ethereumjs_wallet_1.default.fromPrivateKey(Buffer.from(Utils_1.removeHexPrefix(privateKey), 'hex'));
  return wallet.getChecksumAddressString();
}

var AccountManager = /*#__PURE__*/function () {
  function AccountManager(provider, chainId, config) {
    _classCallCheck(this, AccountManager);

    this.accounts = [];
    this.web3 = new web3_1.default(provider);
    this.chainId = chainId;
    this.config = config;
  }

  _createClass(AccountManager, [{
    key: "addAccount",
    value: function addAccount(privateKey) {
      // TODO: backwards-compatibility 101 - remove on next version bump
      // addAccount used to accept AccountKeypair with Buffer in it
      // @ts-ignore
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (privateKey.privateKey) {
        console.error('ERROR: addAccount accepts a private key as a prefixed hex string now!'); // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions

        privateKey = "0x".concat(privateKey.privateKey.toString('hex'));
      }

      var address = toAddress(privateKey);
      var keypair = {
        privateKey: privateKey,
        address: address
      };
      this.accounts.push(keypair);
    }
  }, {
    key: "newAccount",
    value: function newAccount() {
      var a = ethereumjs_wallet_1.default.generate();
      var privateKey = "0x".concat(a.privKey.toString('hex'));
      this.addAccount(privateKey);
      var address = toAddress(privateKey);
      return {
        privateKey: privateKey,
        address: address
      };
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(relayRequest) {
        var signature, forwarder, cloneRequest, signedData, keypair, rec;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                forwarder = relayRequest.relayData.forwarder;
                cloneRequest = Object.assign({}, relayRequest);
                signedData = new TypedRequestData_1.TypedRequestData(this.chainId, forwarder, cloneRequest);
                keypair = this.accounts.find(function (account) {
                  return Utils_1.isSameAddress(account.address, relayRequest.request.from);
                });
                _context.prev = 4;

                if (!(keypair != null)) {
                  _context.next = 9;
                  break;
                }

                signature = this._signWithControlledKey(keypair.privateKey, signedData);
                _context.next = 12;
                break;

              case 9:
                _context.next = 11;
                return this._signWithProvider(signedData);

              case 11:
                signature = _context.sent;

              case 12:
                // Sanity check only
                // @ts-ignore
                rec = eth_sig_util_1.default.recoverTypedSignature_v4({
                  // @ts-ignore
                  data: signedData,
                  sig: signature
                });
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](4);
                throw new Error("Failed to sign relayed transaction for ".concat(relayRequest.request.from, ": ").concat(_context.t0));

              case 18:
                if (Utils_1.isSameAddress(relayRequest.request.from.toLowerCase(), rec)) {
                  _context.next = 20;
                  break;
                }

                throw new Error("Internal RelayClient exception: signature is not correct: sender=".concat(relayRequest.request.from, ", recovered=").concat(rec));

              case 20:
                return _context.abrupt("return", signature);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 15]]);
      }));

      function sign(_x) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }() // These methods is extracted to
    // a) allow different implementations in the future, and
    // b) allow spying on Account Manager in tests

  }, {
    key: "_signWithProvider",
    value: function () {
      var _signWithProvider2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(signedData) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Utils_1.getEip712Signature(this.web3, signedData, this.config.methodSuffix, this.config.jsonStringifyRequest);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _signWithProvider(_x2) {
        return _signWithProvider2.apply(this, arguments);
      }

      return _signWithProvider;
    }()
  }, {
    key: "_signWithControlledKey",
    value: function _signWithControlledKey(privateKey, signedData) {
      // @ts-ignore
      return eth_sig_util_1.default.signTypedData_v4(Buffer.from(Utils_1.removeHexPrefix(privateKey), 'hex'), {
        data: signedData
      });
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      return this.accounts.map(function (it) {
        return it.address;
      });
    }
  }]);

  return AccountManager;
}();

exports.AccountManager = AccountManager;